import React from 'react';
import { withTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { Theme, ThemeProps } from '@theme/base';
import { mq } from '@styles/breakpoints';
import { TourTestimonial } from '@model/iceberg/testimonial';
import { TripTypes } from '@model/common';
import { TestId } from '@components/test-ids';
import { useElapsedTimer } from '@components/hooks';
import { TourReview } from '../review';
import { ProgressBar } from './ProgressBar';

export interface TourCarouselProps {
  timeout: number;
  testimonials: Array<TourTestimonial>;
  destinationName: string;
  theme: Theme;
  tripType: TripTypes;
}

const Container = styled.div(({ theme }: ThemeProps) => ({
  backgroundColor: theme.custom.colors.overlay.dark,
  backdropFilter: 'blur(10px)',
  borderRadius: theme.custom.spacing.small,
  margin: `${theme.custom.spacing.xxxLarge}px ${theme.custom.spacing.medium}px`,
  overflow: 'hidden',
  [mq.medium]: {
    margin: 0
  }
}));

const getProgress = (elapsedTime: number, maxTime: number) => (elapsedTime / maxTime) * 100;

export const TourCarouselComponent = ({ timeout, testimonials, destinationName, tripType }: TourCarouselProps) => {
  const { elapsedTime, index } = useElapsedTimer(timeout, testimonials.length);
  return (
    <Container data-testid={TestId.testimonial.carousel}>
      <TourReview testimonial={testimonials[index]} destinationName={destinationName} tripType={tripType} />
      <ProgressBar width={getProgress(elapsedTime, timeout)} />
    </Container>
  );
};

export const TourCarousel = withTheme(TourCarouselComponent);
